import React, { Component } from "react";
import PropTypes from "prop-types";
import utils from "@utils";
import { PaymentService } from "@services";
import Modal from "../Modal/Modal";
import Image from "../Image/Image";
import ScrollDetect from "../ScrollDetect/ScrollDetect";

import "./MultipleOfficerModal.scss";

class MultipleOfficerModal extends Component {
	constructor(props) {
		super(props);
		this.initialState = {
			invoiceId: null,
			officerList: [],
			loading: false,
			hasMore: false,
			pageNumber: 1,
			searchToggled: false,
		};

		this.state = { ...this.initialState };
	}

	componentDidUpdate({ show: prevShow }) {
		const { show } = this.props;
		if (prevShow !== show && show) {
			this.onModalRender();
		}
	}

	onModalRender = () => {
		const { invoiceId } = this.props;
		this.setState({}, () => {
			this.getOfficers(invoiceId);
		});
	};

	/**
	 * Retrieves a paginated list of officers
	 */
	getOfficers = invoiceId => {
		const { lang } = global;
		const { pageNumber } = this.state;
		PaymentService.getNonRKPayInvoiceOfficers(invoiceId, {
			pageNumber,
			displayCount: 25,
		})
			.then(({ data }) => {
				this.setState({
					pageNumber: data.Page,
					officerList: data.ItemList,
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading officers"),
					timeOut: 1500,
				});
			});
	};

	render() {
		const { lang } = global;
		const { show, onHide } = this.props;
		const { officerList, hasMore } = this.state;
		return (
			<Modal
				id="multiple-officer-modal"
				show={show}
				onHide={onHide}
			>
				<Modal.Header closeButton>
					<Modal.Title>{lang.t("Officers on Invoice")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="officer-list">
						<For
							each="officer"
							of={officerList}
						>
							<div
								key={`officer-results_${officer.Id}`}
								className="row"
							>
								<div className="col-xs-4 col-sm-2">
									<Image
										className="img-circle img-responsive"
										src={officer.ContactPhotoUrl}
										fallbackSrc="avatar"
										alt={`${officer.FirstName} ${officer.LastName}'s profile picture`}
									/>
								</div>
								<div className="col-xs-8">
									<strong className="text-capitalize">
										{officer.FirstName} {officer.LastName}
									</strong>
									<If condition={officer?.Department}>
										<div>{`${lang.t("Jurisdiction")}: ${officer.Department}`}</div>
									</If>
									<If condition={officer?.OfficerRank}>
										<div>{`${lang.t("Rank")}: ${officer.OfficerRank}`}</div>
									</If>
								</div>
							</div>
						</For>
						<If condition={hasMore}>
							<ScrollDetect
								className="text-center no-overflow"
								onVisible={this.getOfficers}
							>
								<i className="glyphicon glyphicon-repeat rkf-spin rkf-fw" />
							</ScrollDetect>
						</If>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						id="cancel-search-contact"
						className="btn btn-link"
						onClick={onHide}
					>
						{lang.t("Close")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

MultipleOfficerModal.propTypes = {
	show: PropTypes.bool,
	invoiceId: PropTypes.object,
	onHide: PropTypes.func,
};

MultipleOfficerModal.defaultProps = {
	show: false,
	invoiceId: PropTypes.object,
	onHide: () => {},
};

export default MultipleOfficerModal;
